import React from 'react';

import FileUpload from '../editor/FileUpload'
import Link from '../editor/Link'
import Search from '../editor/Search'

const ABridTileNarrowEditor = (props) => {
    return (
        <div>
            {props.children}
            <Search />
            <hr />
            <Link value={props.settings.link} />
            <div className="form-group">
                <label className="col-sm-3 control-label">Tytuł</label>
                <div className="col-sm-9">
                    <input type="text" name="title_normal" className="form-control" defaultValue={props.settings.title_normal} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">Tytuł atrykułu nr1</label>
                <div className="col-sm-9">
                    <input type="text" name="title_button1" className="form-control" defaultValue={props.settings.title_button1} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">ID artykułu nr1</label>
                <div className="col-sm-9">
                    <input required type="text" name="article1_id" className="form-control" defaultValue={props.settings.article1_id} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">Tytuł artykułu nr2</label>
                <div className="col-sm-9">
                    <input type="text" name="title_button2" className="form-control" defaultValue={props.settings.title_button2} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">ID artykułu nr2</label>
                <div className="col-sm-9">
                    <input required type="text" name="article2_id" className="form-control" defaultValue={props.settings.article2_id} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">Tytuł artykułu nr3</label>
                <div className="col-sm-9">
                    <input type="text" name="title_button3" className="form-control" defaultValue={props.settings.title_button3} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">ID artykułu nr3</label>
                <div className="col-sm-9">
                    <input required type="text" name="article3_id" className="form-control" defaultValue={props.settings.article3_id} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">Czas w formacie "RRRR-MM-DD GG:mm"</label>
                <div className="col-sm-9">
                    <input type="text" name="time" className="form-control" defaultValue={props.settings.time} placeholder="" />
                </div>
            </div>
            <FileUpload value={props.settings['background-image']} />
        </div>
    );
}


export default ABridTileNarrowEditor;